import Vue from 'vue';

// const RiotsTable = () => import(/* webpackChunkName: "InvRiotsTable" */ "./RiotsTable.vue");
import RiotsTable from './RiotsTable.vue';

function init_vue_app(selector){
    new Vue({
        el: selector,
        render: h => h(RiotsTable),
    });

     // Set scroll bar width for css table sizing
    setScrollbarWidth();
    
    document.addEventListener("DOMContentLoaded", function(){
        // Handler when the DOM is fully loaded
        setScrollbarWidth();
    });
    
    window.addEventListener('resize', function(event) {
        setScrollbarWidth();
    }, true);
    
    function setScrollbarWidth() {
        document.documentElement.style.setProperty('--scrollbarWidth', (window.innerWidth - document.documentElement.clientWidth) + "px");
    }
}

function lazy_init_app(selector){

    var lazy_init_callback = function(){
        if( window.$(selector) && window.$(selector).inViewport(50) ){
            init_vue_app(selector);
            $(window).off("scroll rezise", lazy_init_callback);
        }
    }

    $(window).on('scroll rezise', lazy_init_callback).scroll().resize();
}

function init_app(){
    lazy_init_app('#riots-table');
}

export default init_app;